import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { twMerge } from "tailwind-merge";

import type { DiagnosticCheck } from "../types";

interface DiagnosticCheckItemProps {
  check: DiagnosticCheck;
}

export function DiagnosticCheckItem({ check }: DiagnosticCheckItemProps) {
  const { bgClass, borderClass, icon, textClass } = STATUS_CONFIG[check.status];

  return (
    <div
      className={twMerge(
        "flex items-start gap-3 rounded-lg border px-4 py-3",
        borderClass,
        bgClass,
      )}
    >
      <div className="mt-0.5 shrink-0">{icon}</div>
      <div className="flex flex-col gap-0.5">
        <span className={twMerge("text-sm font-medium", textClass)}>
          {check.title}
        </span>
        <span className="text-sm text-text-tertiary">{check.description}</span>
      </div>
    </div>
  );
}

const STATUS_CONFIG = {
  fail: {
    bgClass: "bg-transparent",
    borderClass: "border-red-300",
    icon: <AlertTriangle className="text-red-500" size={16} />,
    textClass: "text-text-primary",
  },
  pass: {
    bgClass: "bg-transparent",
    borderClass: "border-[#079455]",
    icon: <CheckCircle2 className="text-[#079455]" size={16} />,
    textClass: "text-text-primary",
  },
  warning: {
    bgClass: "bg-transparent",
    borderClass: "border-amber-300",
    icon: <AlertTriangle className="text-amber-500" size={16} />,
    textClass: "text-text-primary",
  },
} as const satisfies Record<
  DiagnosticCheck["status"],
  {
    bgClass: string;
    borderClass: string;
    icon: React.ReactNode;
    textClass: string;
  }
>;
